// extracted by mini-css-extract-plugin
export default {"container":"SideBarItem_container__kLNtl","item":"SideBarItem_item__sezlw","item__text":"SideBarItem_item__text__AarNb","item__isOpen":"SideBarItem_item__isOpen__Wtp7T"};